import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import routes from "./routes"; // This is now your route object array
import { AuthProvider } from "./context/AuthContext";

import "./index.css";
import "./assets/css/global.css";
import "./assets/css/default.css";
import "./assets/css/marketplace.css";
import "./assets/css/customToastify.css";

const queryClient = new QueryClient();
const router = createBrowserRouter(routes);

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <QueryClientProvider client={queryClient}>
    {/* Outside RouterProvider: auth state has to survive route changes and be
        readable by the guard on the very first render. */}
    <AuthProvider>
      <RouterProvider router={router} />
    </AuthProvider>
    {/* TODO: Install reatc query dev tools to view cached data */}
  </QueryClientProvider>
);
